import {Route} from 'react-router'
import {Home} from './index'

export const routes = (
	<>
		<Route index element={<Home />} />
		<Route path="home" element={<Home />} />
	</>
)
